import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingShopManageForm(props) {
  return (
    <SpaceRoleRangeForm
      {...props}
      role="shop_manager"
      settingKey="shop_manager_role_setting"
    />
  );
}

export default SpacesSettingShopManageForm;
